import { type InputHTMLAttributes, forwardRef, type ReactNode } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className = '', hasError, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={`w-full h-12 px-4 rounded-2xl bg-paper-50 border ${
        hasError ? 'border-danger' : 'border-paper-300 focus:border-violet-500'
      } font-sans text-ink placeholder:text-ink-600/60 focus:outline-none focus:ring-2 focus:ring-violet-500/20 transition-colors duration-150 ${className}`}
      {...rest}
    />
  );
});

interface LabelProps {
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}
export function Label({ htmlFor, children, className = '' }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={`block text-sm font-sans font-medium text-ink-700 mb-1.5 ${className}`}
    >
      {children}
    </label>
  );
}

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  children: ReactNode;
}
export function FormField({ label, htmlFor, error, hint, children }: FormFieldProps) {
  return (
    <div>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {error && <p className="mt-1.5 text-xs text-danger">{error}</p>}
      {!error && hint && <p className="mt-1.5 text-xs text-ink-600">{hint}</p>}
    </div>
  );
}
